// FILE: src/pages/Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-blue-100 to-blue-300 text-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Institute Management System</h1>
        <p className="text-xl text-gray-600 mb-8">Welcome to our comprehensive institute management platform</p>
      </div>
      <Link to="/login" className="px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700">Login</Link>
    </div>
  );
}

export default Home;
